import React from 'react';

import { ReactComponent as PGSupportIcon } from '@pharmaplan/common/assets/icons/pharmagapChatIcon.svg';
import { ReactComponent as PharmacistChatIcon } from '@pharmaplan/common/assets/icons/pharmacistChatIcon.svg';
import { ReactComponent as TechnicianChatIcon } from '@pharmaplan/common/assets/icons/technicianChatIcon.svg';
import { ReactComponent as StudentChatIcon } from '@pharmaplan/common/assets/icons/studentChatIcon.svg';
import { ReactComponent as PharmacyIcon } from '@pharmaplan/common/assets/icons/pharmacyChatIcon.svg';
import {
  chatActiveTab,
  ClientChatTypes,
  createGroupChannel,
  getTypeOfUser,
  TypeOfUser,
} from '@pharmaplan/common';
import { ReactComponent as SupportIcon } from '../../assets/svg/pharmaplanEmail.svg';
import { ReactComponent as UsersChatIcon } from '../../assets/svg/usersChatIcon.svg';

import strings from '../../localization';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import useProfessional from '../Professional/useProfessional';
import useSelfService from '../useSelfService';

const { pharmacist, pharmacy, admin, superAdmin, technician, student } = TypeOfUser;
interface IConfig {
  key: ClientChatTypes;
  icon: JSX.Element;
  label: string;
  handleClick?: () => void;
}
const useChatSidebar = () => {
  const dispatch = useAppDispatch();
  const userType = useAppSelector(getTypeOfUser);
  const activeTab = useAppSelector(chatActiveTab);

  const { selfUserType } = useProfessional();
  const { isSelfService } = useSelfService();

  const initiateSupport = () => {
    dispatch(createGroupChannel(selfUserType?.toLowerCase()));
  };

  const generalIcons: Array<IConfig> = [
    {
      key: ClientChatTypes.support,
      icon: isSelfService ? <PGSupportIcon /> : <SupportIcon />,
      label: strings.support,
      handleClick: initiateSupport,
    },
  ];

  const professionalIcons: Array<IConfig> = [
    ...generalIcons,
    {
      key: ClientChatTypes.pharmacy,
      icon: <PharmacyIcon />,
      label: strings.pharmacy,
    },
  ];

  const pharmacyIcons: Array<IConfig> = [
    ...generalIcons,
    {
      key: ClientChatTypes.pharmacist,
      icon: <PharmacistChatIcon />,
      label: strings.pharmacist,
    },
    {
      key: ClientChatTypes.technician,
      icon: <TechnicianChatIcon />,
      label: strings.technician,
    },
    {
      key: ClientChatTypes.student,
      icon: <StudentChatIcon />,
      label: strings.pharmacyStudent,
    },
  ];

  const adminIcons: Array<IConfig> = [
    {
      key: ClientChatTypes.pharmacy,
      icon: <PharmacyIcon />,
      label: strings.pharmacy,
    },
    {
      key: ClientChatTypes.pharmacist,
      icon: <PharmacistChatIcon />,
      label: strings.pharmacist,
    },
    {
      key: ClientChatTypes.technician,
      icon: <TechnicianChatIcon />,
      label: strings.technician,
    },
    {
      key: ClientChatTypes.student,
      icon: <StudentChatIcon />,
      label: strings.pharmacyStudent,
    },
    {
      key: ClientChatTypes.users,
      icon: <UsersChatIcon />,
      label: strings.usersChat,
    },
  ];

  const config = {
    [pharmacy]: pharmacyIcons,
    [pharmacist]: professionalIcons,
    [technician]: professionalIcons,
    [student]: professionalIcons,
    [admin]: adminIcons,
    [superAdmin]: adminIcons,
  };

  return { icons: isSelfService ? config[userType as keyof typeof config] : generalIcons, activeTab };
};
export default useChatSidebar;
